module.exports = __webpack_public_path__ + "img/img_copy.6690498d.png";